let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j3iEF")).then(() => parcelRequire('6UZcZ'));